import { useState, useMemo, useId } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { Layout } from '../components/layout'
import { Input } from '../components/input'
import { Button } from '../components/button'
import { useSetAtom } from 'jotai'
import { toastAtom } from '../store/toast.store.js'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loggingIn, setLoggingIn] = useState(false)
  // const [error, setError] = useState('')

  const passwordInputId = useId()

  const addToast = useSetAtom(toastAtom)

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const redirectUrl = useMemo(() => {
    const param = searchParams.get('next')

    if (!param) return

    return decodeURIComponent(param)
  }, [searchParams])

  const handleLogin = async (e) => {
    e.preventDefault()

    if (!email || !password) return null

    // setError('')
    setLoggingIn(true)

    const auth = getAuth()

    await signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        // Signed in
        setLoggingIn(false)

        if (redirectUrl) return navigate(redirectUrl)

        return navigate('/dashboard')
      })
      .catch((error) => {
        const errorCode = error.code
        setLoggingIn(false)
        console.error(errorCode)
        switch (errorCode) {
          case 'auth/user-not-found':
            addToast({ title: "We couldn't find your account", type: 'fail' })
            break
          case 'auth/wrong-password':
            addToast({
              title: 'Your email and password did not match',
              type: 'fail',
            })
            break

          default:
            addToast({
              title: 'An error occurred',
              body: 'Please try again',
              type: 'fail',
            })
            break
        }
      })
  }
  return (
    <Layout title="Login" announcement>
      <form onSubmit={(e) => handleLogin(e)} className="flex flex-col gap-4">
        <Input
          label="Email"
          type="email"
          data-label="email-input"
          placeholder="me@email.com"
          autoFocus
          value={email}
          onChange={(change) => setEmail(change)}
          InputProps={{
            name: 'email',
          }}
        />
        <Input
          id={passwordInputId}
          label="Password"
          type="password"
          data-label="password-input"
          placeholder="••••••••••"
          value={password}
          onChange={(change) => setPassword(change)}
          InputProps={{
            name: 'password',
          }}
        />
        <Button
          data-label="login-button"
          disabled={!email || !password || loggingIn}
          loading={loggingIn}
          text={<span>{loggingIn ? 'Logging you in...' : 'Login'}</span>}
          onClick={() => {}}
          type="submit"
        />
      </form>

      <p className="text-sm text-gray-200">
        Don&apos;t have an account?{' '}
        <Link
          to={`/signup${window?.location?.search}`}
          className="text-blue-500 hover:underline"
        >
          Sign up here
        </Link>
      </p>
      <p className="text-sm text-gray-200">
        <Link to="/reset" className="text-blue-500 hover:underline">
          Reset password
        </Link>
      </p>
    </Layout>
  )
}
